import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetMountedStorageSettingsQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
  projectId: Types.Scalars['ID']['input'];
}>;


export type GetMountedStorageSettingsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, mountedStorageEnabled: boolean, project?: { __typename?: 'Project', id: string, mountedStorageStatus?: Types.MountedStorageStatus | null, mountedStorageDriveLetter?: Types.MountedStorageDriveLetter | null, permissions?: { __typename?: 'ProjectPermissions', canMount: boolean, mountErrors?: Array<Types.MountErrorCode> | null } | null } | null } | null };


export const GetMountedStorageSettings = /*#__PURE__*/ gql`
    query GetMountedStorageSettings($accountId: ID!, $projectId: ID!) {
  account(by: {id: $accountId}) {
    id
    mountedStorageEnabled
    project(id: $projectId) {
      id
      mountedStorageStatus
      mountedStorageDriveLetter
      permissions {
        canMount
        mountErrors
      }
    }
  }
}
    ` as unknown as DocumentNode<GetMountedStorageSettingsQuery, GetMountedStorageSettingsQueryVariables>;

          

          export const useGetMountedStorageSettingsQuery = (options?:QueryHookOptions<GetMountedStorageSettingsQuery, GetMountedStorageSettingsQueryVariables>) => useQuery(GetMountedStorageSettings, options);

          

          export type GetMountedStorageSettingsQueryOptions = QueryHookOptions<GetMountedStorageSettingsQuery, GetMountedStorageSettingsQueryVariables>;

          

          export const useGetMountedStorageSettingsLazyQuery = (options?:LazyQueryHookOptions<GetMountedStorageSettingsQuery, GetMountedStorageSettingsQueryVariables>) => useLazyQuery(GetMountedStorageSettings, options);

          

          export type GetMountedStorageSettingsQueryResult = ReturnType<typeof useGetMountedStorageSettingsQuery>;

          
